import { MaskedLine, Reveal, Eyebrow } from "@/components/Reveal";
import TickerTape from "@/components/TickerTape";
import { AdvancedChart, MarketOverview, Screener, EconomicCalendar } from "@/components/TradingView";

export default function Markets() {
    return (
        <>
            <section data-testid="markets-hero" className="relative overflow-hidden">
                <div className="pointer-events-none absolute -top-40 right-[-10%] h-[28rem] w-[28rem] rounded-full bg-[#D4AF37]/10 blur-3xl" />
                <div className="mx-auto max-w-7xl px-6 pt-40 pb-16 md:px-10 md:pt-48 md:pb-20">
                    <MaskedLine delay={0.05}>
                        <Eyebrow>Live market terminal</Eyebrow>
                    </MaskedLine>
                    <h1 className="mt-8 max-w-4xl font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-balance">
                        <MaskedLine delay={0.2}>Watch the markets</MaskedLine>
                        <MaskedLine delay={0.34}>
                            <span className="font-editorial italic font-light text-gold">we trade.</span>
                        </MaskedLine>
                    </h1>
                    <Reveal delay={0.6} className="mt-8 max-w-2xl">
                        <p className="text-base md:text-lg leading-relaxed text-zinc-400">
                            Real-time coverage of our core universe — gold, silver, crude oil, global
                            indices and the ETFs that track them. The same tape our research desk watches.
                        </p>
                    </Reveal>
                </div>
                <TickerTape />
            </section>

            <section data-testid="markets-chart-section" className="mx-auto max-w-7xl px-6 py-20 md:px-10 md:py-28">
                <Reveal className="flex flex-wrap items-end justify-between gap-6">
                    <div>
                        <Eyebrow>Advanced chart</Eyebrow>
                        <h2 className="mt-5 font-display text-3xl md:text-4xl font-extrabold tracking-tight">
                            Gold, front and centre.
                        </h2>
                    </div>
                    <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
                        Switch symbols inside the chart
                    </p>
                </Reveal>
                <Reveal delay={0.12} className="mt-10">
                    <div className="border border-white/10 bg-black/40 p-1">
                        <AdvancedChart symbol="TVC:GOLD" height={560} testId="markets-advanced-chart" />
                    </div>
                </Reveal>
            </section>

            <section data-testid="markets-overview-section" className="border-t border-white/10 bg-coal/30">
                <div className="mx-auto max-w-7xl px-6 py-20 md:px-10 md:py-28">
                    <Reveal>
                        <Eyebrow>Market overview & calendar</Eyebrow>
                        <h2 className="mt-5 font-display text-3xl md:text-4xl font-extrabold tracking-tight">
                            Commodities, indices, ETFs — and the events that move them.
                        </h2>
                    </Reveal>
                    <div className="mt-10 grid gap-6 lg:grid-cols-2">
                        <Reveal delay={0.1}>
                            <div className="border border-white/10 bg-black/40 p-1">
                                <MarketOverview height={560} testId="markets-market-overview" />
                            </div>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <div className="border border-white/10 bg-black/40 p-1">
                                <EconomicCalendar height={560} testId="markets-economic-calendar" />
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>

            <section data-testid="markets-screener-section" className="mx-auto max-w-7xl px-6 py-20 md:px-10 md:py-28">
                <Reveal>
                    <Eyebrow>Equity & ETF screener</Eyebrow>
                    <h2 className="mt-5 font-display text-3xl md:text-4xl font-extrabold tracking-tight">
                        Screen the market like a desk.
                    </h2>
                </Reveal>
                <Reveal delay={0.12} className="mt-10">
                    <div className="border border-white/10 bg-black/40 p-1">
                        <Screener height={560} testId="markets-screener" />
                    </div>
                    <p className="mt-4 font-mono text-[11px] text-zinc-600">
                        Market data provided by TradingView. For information only — not investment advice.
                    </p>
                </Reveal>
            </section>
        </>
    );
}
